<hslayers style="height: calc(var(--vh, 1vh) * 100)"></hslayers>
<a href="https://smartagrihubs.eu/" target="_blank"><img [src]="MainService.assetsPath + 'images/logo.svg'" style="position: absolute; top: 0; right: 1em"/></a>